<template>
  <div class="flex items-center sm:block">
    <label class="sm:hidden mr-4 font-medium whitespace-no-wrap flex flex-col">
      <span>Suitable for</span>
      <span class="text-sm font-normal">(select up to 3)</span>
    </label>
    <span class="text-sm font-bold sm:block hidden mb-2"
      >Suitable for (select up to 3)</span
    >

    <ul
      ref="tabHeader"
      class="gap-6 sm:gap-2 sm:pb-5 flex-1 flex no-scrollbar overflow-x-scroll"
    >
      <li
        v-for="tag in tags"
        :key="tag.value"
        class="tag-item flex flex-col items-center px-2 cursor-pointer opacity-75"
        :class="{ 'is-selected opacity-100': selectedTag.includes(tag.value) }"
        @click="$emit('handle-select-tag', tag)"
      >
        <img width="25" height="25" :src="tag.icon" />
        <span
          class="whitespace-no-wrap sm:text-sm"
          :class="{ 'font-bold': selectedTag.includes(tag.value) }"
        >
          {{ tag.title }}
        </span>
      </li>
    </ul>
    <div class="sm:hidden flex-none ml-4" v-if="tags.length">
      <button type="button" @click="scrollTabLeft">
        <svg width="24" height="24">
          <use xlink:href="/img/sprite.svg#ic_chevron-left"></use>
        </svg>
      </button>
      <button type="button" @click="scrollTabRight">
        <svg width="24" height="24">
          <use xlink:href="/img/sprite.svg#ic_chevron-right"></use>
        </svg>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    selectedTag: {
      type: Array,
      default: [],
    },
    tags: {
      type: Array,
      default: [],
    },
  },
  methods: {
    scrollTabRight() {
      $(this.$refs.tabHeader).animate(
        {
          scrollLeft: this.$refs.tabHeader.scrollLeft + 200,
        },
        200
      );
    },
    scrollTabLeft() {
      $(this.$refs.tabHeader).animate(
        {
          scrollLeft: this.$refs.tabHeader.scrollLeft - 200,
        },
        200
      );
    },
  },
};
</script>

<style scoped>
ul ::v-deep li {
  margin-bottom: 0px !important;
}
.tag-item {
  border-bottom: 2px solid transparent;
}

.is-selected {
  border-bottom: 5px solid var(--secondary);
  transition: 0.3s;
}
</style>
